import * as _ from "lodash-es";
import sysConfig from "@/config";
import {getValue} from "./cache";
import {getLanguage} from "./load";
import {createI18n} from 'vue-i18n';
import {Template} from "@js-lion/template";
import safeGet from "@fengqiaogang/safe-get";

const list = ["zh-cn", "en", "hk", "ka", "ja"];

const get = function (target, prop) {
  if (_.includes(list, prop)) {
    return getValue(prop);
  } else {
    return safeGet(target, prop) || prop;
  }
}
const messages = new Proxy({}, {get});


const language = createI18n({
  messages, locale: getLanguage(), globalInjection: true, fallbackLocale: sysConfig.LANG,
});

const LanguageProxy = function (key) {
  let name;
  if (key === 0) {
    name = "0";
  } else {
    name = String(key || "").trim();
  }
  if (name && /^\w+(\.\w+)+$/i.test(name)) {
    try {
      return language?.global?.t(name);
    } catch (e) {
      // todo
    }
  }
  return key;
}

const join = function (...args) {
  const list = [];
  const language = getLanguage();
  for (let i = 0, len = args.length; i < len; i++) {
    const text = LanguageProxy(args[i]);
    if (i === 0) {
      list.push(_.trimEnd(text));
    } else if (i === len - 1) {
      list.push(_.trimStart(text));
    } else {
      list.push(_.trim(text));
    }
  }
  return language === "en" ? list.join(" ") : list.join("");
}

export const i18n = function (...args) {
  if (args.length > 1) {
    return join(...args);
  } else {
    return LanguageProxy(args[0]);
  }
}

const template = function (text, data) {
  const tpl = Template(/:([\w-]+)/ig, text);
  return tpl(function ($1, name) {
    return data[name] || name;
  });
};

i18n.join = join;
i18n.template = function (key, data) {
  const text = LanguageProxy(key);
  return template(text, data);
}

export {getLanguage};

export default language;